var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.6,
    height: 34.576,
    viewBox: "-3 2 60 30",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#01010C",
    d: "M8.834 6.098c6.823 8.821 15.113 16.417 24.43 22.538 2.698 1.772 5.205-2.556 2.524-4.317-8.965-5.89-16.858-13.274-23.419-21.756-.827-1.069-2.666-.87-3.535 0-1.055 1.055-.83 2.464 0 3.535Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#01010C",
    d: "M35.34.713.724 30.328c-1.026.878-.902 2.633 0 3.535 1.018 1.018 2.507.88 3.536 0L38.876 4.248c1.026-.878.902-2.633 0-3.535-1.018-1.018-2.507-.88-3.536 0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/x-mark.e6190e1a01b029c9055fbd86c467e63d.svg";
export { ForwardRef as ReactComponent };